import { configureStore } from '@reduxjs/toolkit';
import playerReducer from './modules/reducers';

const store = configureStore({
  reducer: playerReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: false }),
});

export default store;
